import IframeBlock from './IframeBlock';

export default IframeBlock;
